import { useIntl } from "react-intl";
import { InfoTooltip } from "./InfoTooltip";
import type { SkillLevel } from "../../lib/skill-levels";

export function SkillLevelInfoIcon({
  level,
  placement = "top",
  className = "",
}: {
  level: SkillLevel;
  placement?: "top" | "bottom" | "left" | "right";
  className?: string;
}) {
  const intl = useIntl();
  return (
    <InfoTooltip
      ariaLabel={intl.formatMessage({ id: "skill.infoLabel", defaultMessage: "Level description" })}
      title={intl.formatMessage({ id: level.titleId, defaultMessage: level.name })}
      placement={placement}
      className={className}
    >
      {intl.formatMessage({ id: level.descriptionId })}
    </InfoTooltip>
  );
}
